import { render, staticRenderFns } from "./LayoutColumnContent.vue?vue&type=template&id=8870385a&"
import script from "./LayoutColumnContent.vue?vue&type=script&lang=js&"
export * from "./LayoutColumnContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports